import { render, staticRenderFns } from "./RegistDetail.vue?vue&type=template&id=51cebba4&"
import script from "./RegistDetail.vue?vue&type=script&lang=js&"
export * from "./RegistDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports